import { useLocation } from "react-router-dom";
import { Reveal } from "@/components/Reveal";
import { BUSINESS } from "@/data/content";

const CONTENT = {
  "/privacy": {
    title: "Privacy Policy",
    intro:
      "This Privacy Policy explains how Masaya Rental Homes LLC collects, uses, and protects the information you provide through this website.",
    sections: [
      { h: "Information we collect", p: "When you submit an inquiry or consultation request, we collect the details you provide — such as your name, email address, phone number, preferred dates, and message. We do not collect sensitive personal information through this website." },
      { h: "How we use your information", p: "We use your information solely to respond to your inquiry, arrange stays or consultations, and communicate with you about our services. We do not sell your information to third parties." },
      { h: "Data storage", p: "Inquiry details are stored securely and retained only as long as necessary to serve you and meet legal or operational requirements." },
      { h: "Your choices", p: "You may request that we update or delete your information at any time by contacting us at " + BUSINESS.email + "." },
    ],
  },
  "/terms": {
    title: "Terms of Use",
    intro:
      "By using this website, you agree to the following terms. Please read them carefully.",
    sections: [
      { h: "Use of this website", p: "This website is provided for informational purposes about Masaya Rental Homes LLC and its furnished housing services. Content may be updated or changed at any time without notice." },
      { h: "No booking or contract", p: "Submitting an inquiry does not create a reservation, lease, or binding agreement. All stays and management partnerships are subject to separate written agreements and availability." },
      { h: "Property information", p: "Photos, availability, and descriptions are provided in good faith and may not reflect real-time conditions. Exact addresses are shared privately as part of the booking process." },
      { h: "Contact", p: "Questions about these terms can be directed to " + BUSINESS.email + "." },
    ],
  },
};

export default function Legal() {
  const { pathname } = useLocation();
  const data = CONTENT[pathname] || CONTENT["/privacy"];

  return (
    <section data-testid="legal-page" className="px-6 md:px-12 pt-36 md:pt-40 pb-24 md:pb-32">
      <div className="max-w-3xl mx-auto">
        <Reveal>
          <span className="text-xs sm:text-sm tracking-[0.2em] uppercase font-medium text-[#8A9A86]">Legal</span>
          <h1 className="mt-5 text-4xl sm:text-5xl tracking-tighter font-light leading-none text-[#1C1917]">{data.title}</h1>
          <p className="mt-8 text-lg text-[#44403C] leading-relaxed font-light">{data.intro}</p>
        </Reveal>

        <div className="mt-14 space-y-12">
          {data.sections.map((s, i) => (
            <Reveal key={s.h} delay={i * 0.05}>
              <h2 className="text-2xl font-normal tracking-tight text-[#1C1917] mb-3">{s.h}</h2>
              <p className="text-[#44403C] leading-relaxed font-light">{s.p}</p>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.1}>
          <p className="mt-16 text-sm text-[#78716C]">© {new Date().getFullYear()} {BUSINESS.legalName}. {BUSINESS.city}.</p>
        </Reveal>
      </div>
    </section>
  );
}
